import { useFetchCssVars } from 'ContentData/queries/GlobalStylesQuery';
import { useLoadGlobalStylesCssVars } from '../../../hooks/useLoadGlobalStyles';
import { PREVIEW_CLASSNAME } from '../../../constants/GlobalStyles';
export const StylesLoader = () => {
  const {
    data
  } = useFetchCssVars({}, {
    bufferTheme: true,
    fetchPolicy: 'cache-and-network',
    cssWrapperSelector: `.${PREVIEW_CLASSNAME}`
  });
  useLoadGlobalStylesCssVars(data);
  return null;
};